import type { DanceSeoHead } from "../danceSeoTypes.js";

// Search Console, Aug 29 - Sep 26 2026. The full-song page's queries are
// "ai dance video generator", "ai dance generator from music", "music to
// dance video ai" and their "free" variants; the photo page's are "photo
// dance", "make a photo dance", "ai dance generator from photo", "photo dance
// ai". One head term per page: the first owns "AI dance video generator",
// the second owns "photo dance / from photo".
//
// Oct 30 2026 (Search Console, Oct 2-29): the full-song page's biggest
// searches are the "free" ones, "ai dance video generator free" (1,613
// impressions, #8.4) and "free ai dance video generator" (585, #9.0). The
// title keeps that word order and names the one thing that is free: the
// preview. The video itself is not free (unlike /ai-music-generator, whose
// songs are), so the title never says "Free AI Dance Video Generator". The
// description states the free tier as the code grants it
// (shared/danceSeoLocales/en.ts "Pricing and the free plan"): 100 one-time
// credits on a web signup, no card, one short 480p preview with a watermark;
// paid plans render the whole song.
const head: DanceSeoHead = {
  director: {
    title: "AI Dance Video Generator from Music — Try a Free Preview",
    description:
      "AI dance video generator, free to try: 100 credits on signup, no credit card, for a short 480p dance preview with a watermark. Paid plans render the whole song.",
    h1: "AI Dance Video Generator — Turn Any Song into a Dance Video",
  },
  photo: {
    title: "Make a Photo Dance — AI Dance Generator from Photo | Solmi",
    description:
      "Make a photo dance with AI: upload a full-body photo, pick a move or upload your own dance clip, add a song. Solmi syncs the dance to the beat. Free to start.",
    h1: "Make a Photo Dance — AI Dance Generator from Photo",
  },
  inbound:
    "Want the performer to dance? The [AI dance video generator](/ai-dance-video-generator) plans choreography for every section of your song and renders a full dance video.",
};

export default head;
